import React, { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import Icon from '@common/assets';
import styles from '../../skill.module.scss';
import { ExaminationVO } from '@domain/vo/profile/ProfileSkillVO';

import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface IExaminationChipItemProps {
  prefixName: string;
  examination: ExaminationVO;
  onDelete: () => void;
}

const ExaminationChipItem: FC<IExaminationChipItemProps> = ({ prefixName, examination, onDelete }) => {
  const { control } = useFormContext();

  const { field: codeField } = useController({
    name: `${prefixName}.code`,
    control,
    defaultValue: examination.code,
  });
  const { field: gradeCodeField } = useController({
    name: `${prefixName}.gradeCode`,
    control,
    defaultValue: examination.gradeCode,
  });
  const { field: gradeField } = useController({
    name: `${prefixName}.grade`,
    control,
    defaultValue: examination.grade,
  });
  const { field: scoreField } = useController({
    name: `${prefixName}.score`,
    control,
    defaultValue: examination.score,
  });

  return (
    <li className={cx('listItem')}>
      {examination.labelText}
      <a className={cx('btnDelete')} role="button" onClick={onDelete}>
        <Icon name="closeLight" width={24} height={24} />
      </a>
    </li>
  );
};

interface IExaminationChipListProps {
  prefixName: string;
  examinationChips: ExaminationVO[];
  onDelete: (idx: number) => void;
}

const ExaminationChipList: FC<IExaminationChipListProps> = ({ prefixName, examinationChips, onDelete }) => {
  if (!examinationChips.length) return null;

  const examinationChipsEl = examinationChips.map((item, idx) => {
    return (
      <ExaminationChipItem
        key={item.code}
        prefixName={`${prefixName}[${idx}]`}
        examination={item}
        onDelete={() => onDelete(idx)}
      />
    );
  });

  return <ul className={cx('selectList')}>{examinationChipsEl}</ul>;
};

export default ExaminationChipList;
